export default function isDocumentLoading() {
    return typeof document !== 'undefined' && document.readyState === 'loading';
}
